<template>
  <div class="income-list" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="item" v-for="(item,index) in list" :key="index">
          <div class="item_top">
            <span>{{item.name}}</span>
            <p>{{item.balance}} 金豆</p>
          </div>
          <p>{{item.createAt}}</p>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { List } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "income-list",
  data() {
    return {
      loading: false,   //收入加载状态
      finished: false,  //收入是否完成状态
      list: [],         //收入列表
      pageIndex: 0,
      pageSize:20,
      queryBalanceEvent:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
    }),
    getList(){
      let query=gql`
      query queryBalanceEvent($query:QueryInput!){
        queryBalanceEvent(query:$query){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            balance
            exchangeType
            createAt
            name
            type
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.inMember.memberId
        },
        "EqualB":{
          "n":"exhibitionId",
          "v":this.exhibitionId
        },
        "EqualC":{
          "n":"exchangeType",
          "v":1
        }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("queryBalanceEvent",{ 
        query:query,
        variables:{
         query:opt
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.queryBalanceEvent));
          // let res=data.data.queryProduct;
          console.log('收入余额',res);
          if(res&&res.items.length){
            res.items.forEach(el => {
              el.createAt=moment(el.createAt).format('YYYY/MM/DD HH:mm:ss')
            });
          }
          if(this.pageIndex==1){
            this.list=res.items
          }else{
            this.list=[...new Set([...this.list,...res.items])];
          }
          // console.log(this.list,'list');
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
    },
    //
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
  }
};
</script>

<style scoped lang="scss">
//展品列表
.income-list{
  background: #fff;
  padding: 0 0.3rem;
  .list_wrap{
    .item{
      padding: 0.3rem 0;
      background: #fff;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      flex-direction: column;
      .item_top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
        margin-bottom: 0.15rem;
        span{
          font-size: 0.26rem;
        }
        p{
          font-size: 0.3rem;
          font-weight: bold;
        }
      }
      >p{
        color: #999;
      }
    }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
